$(document).ready(function() {
    $('.team').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1.5, infinite: false }
            }
        ]
    });

    $('.certificates .team-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        prevArrow: $('.slick-prev2'),
        nextArrow: $('.slick-next2'),
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, infinite: true }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1.5, infinite: false }
            }
        ]
    });
});
